import { createFileRoute } from '@tanstack/react-router';
import { LeaveBehindPage } from '@/components/leave-behind/LeaveBehindSheet';
import { LEAVE_BEHIND_EN } from '@/lib/leave-behind';

function LeaveBehindEnglishPage() {
  return <LeaveBehindPage copy={LEAVE_BEHIND_EN} />;
}

export const Route = createFileRoute('/leave-behind/')({
  component: LeaveBehindEnglishPage,
});
